<div class="mainInfo">
  <h1>Registro Finalizado</h1>
  <p>Para continuar, necesitamos que abras la app de Krediya que ha sido instalada, para que puedas reportar tus pagos.</p>
</div>

<footer class="pt-30">
  <div class="footer__content">
    <app-phone-app-footer-button-shared [state]="appState" (continueClick)="onContinue()"></app-phone-app-footer-button-shared>
  </div>
</footer>
